
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./pagestyles/RemoteLogin.css";

const RemoteLogin = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleContinue = () => {
    if (!email) return;

    // Add remote login logic here if needed
    navigate("/");
  };

  const handleSocialLogin = (provider) => {
    console.log(`Login with ${provider}`);
    // Add social login logic here
  };

  return (
    <div className="remote-page">
      <div className="remote-container">
        <h3 className="remote-title">
          Remote Terminal Login
        </h3>

        {/* Email Input */}
        <input
          type="email"
          placeholder="Enter your email"
          className="remote-email-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button className="remote-continue-btn" onClick={handleContinue}>
          Continue
        </button>

        {/* OR Divider */}
        <div className="remote-or-divider">
          <span>OR</span>
        </div>

        {/* Social Buttons */}
        <div className="remote-social-buttons">
          <button
            className="remote-apple-btn"
            onClick={() => handleSocialLogin("Apple")}
          >
            Continue with Apple
          </button>

          <button
            className="remote-google-btn"
            onClick={() => handleSocialLogin("Google")}
          >
            Continue with Google
          </button>

          <button
            className="remote-facebook-btn"
            onClick={() => handleSocialLogin("Facebook")}
          >
            Continue with Facebook
          </button>
        </div>

        {/* Footer Links */}
        <div className="remote-footer">
          <Link to="/forgot-password" className="remote-forgot-link">
            Forgot password?
          </Link>
          <span> | </span>
          <Link to="/signup" className="remote-signup-link">
            Create an account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RemoteLogin;





